import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TimeOffPagination = ({ currentPage, totalPages, limit, onPageChange, onLimitChange }) => {
    const maxVisiblePages = 5;
    const pages = [];
    if (totalPages <= maxVisiblePages) {
        for (let i = 1; i <= totalPages; i++) {
            pages.push(i);
        }
    }
    else {
        pages.push(1);
        if (currentPage > 3) {
            pages.push("...");
        }
        const startPage = Math.max(2, currentPage - 1);
        const endPage = Math.min(totalPages - 1, currentPage + 1);
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        if (currentPage < totalPages - 2) {
            pages.push("...");
        }
        pages.push(totalPages);
    }
    return (_jsxs("div", { className: "mt-4 flex items-center justify-between", children: [_jsx("select", { value: limit, onChange: (e) => onLimitChange(Number(e.target.value)), className: "rounded border p-1", children: [5, 10, 20, 50].map((opt) => (_jsx("option", { value: opt, children: opt }, opt))) }), _jsxs("div", { className: "flex items-center space-x-2", children: [_jsx("button", { onClick: () => onPageChange(Math.max(1, currentPage - 1)), className: `px-3 py-1 rounded ${currentPage === 1 ? "bg-gray-200 text-gray-500" : "bg-gray-100 hover:bg-gray-200"}`, disabled: currentPage === 1, children: "<" }), pages.map((page, index) => typeof page === "number" ? (_jsx("button", { onClick: () => onPageChange(page), className: `px-3 py-1 rounded ${page === currentPage ? "bg-blue-500 text-white" : "bg-gray-100 hover:bg-gray-200"}`, children: page }, index)) : (_jsx("span", { className: "px-3 py-1 text-gray-500", children: page }, index))), _jsx("button", { onClick: () => onPageChange(Math.min(totalPages, currentPage + 1)), className: `px-3 py-1 rounded ${currentPage === totalPages ? "bg-gray-200 text-gray-500" : "bg-gray-100 hover:bg-gray-200"}`, disabled: currentPage === totalPages, children: ">" })] })] }));
};
export default TimeOffPagination;
